export default function ConditionalLogic( { enabled, field, operator, value, cf7Fields, onChange } ) {
	const set = ( key ) => ( val ) => onChange( { [ key ]: val } );

	return (
		<div className="rtwc-section">
			<p className="description rtwc-section-desc">
				Optionally restrict when this webhook fires by checking a field value.
			</p>

			<div className="rtwc-toggle-row">
				<label className="rtwc-switch">
					<input
						type="checkbox"
						checked={ enabled }
						onChange={ ( e ) => set( 'cond_enabled' )( e.target.checked ) }
					/>
					<span className="rtwc-switch-slider" />
				</label>
				<span className="rtwc-toggle-label">
					{ enabled ? 'Conditional logic is enabled' : 'Enable conditional logic' }
				</span>
			</div>

			{ enabled && (
				<div className="rtwc-cond-builder">
					<p className="rtwc-cond-desc">Only fire this webhook when:</p>
					<div className="rtwc-cond-row">
						<div className="rtwc-cond-cell">
							<label className="rtwc-label">Field</label>
							<select
								value={ field }
								onChange={ ( e ) => set( 'cond_field' )( e.target.value ) }
							>
								<option value="">— Select Field —</option>
								{ cf7Fields.map( ( f ) => (
									<option key={ f } value={ f }>{ `[${ f }]` }</option>
								) ) }
							</select>
						</div>
						<div className="rtwc-cond-cell">
							<label className="rtwc-label">Condition</label>
							<select
								value={ operator }
								onChange={ ( e ) => set( 'cond_operator' )( e.target.value ) }
							>
								<option value="equals">Equals</option>
								<option value="not_equals">Not Equals</option>
								<option value="contains">Contains</option>
							</select>
						</div>
						<div className="rtwc-cond-cell">
							<label className="rtwc-label">Value</label>
							<input
								type="text"
								className="regular-text"
								value={ value }
								placeholder="Expected value"
								onChange={ ( e ) => set( 'cond_value' )( e.target.value ) }
							/>
						</div>
					</div>

					{ ( ! field || ! value ) && (
						<p className="rtwc-hint">⚠ Complete all fields above for the condition to take effect.</p>
					) }
					{ ! cf7Fields.length && (
						<p className="rtwc-hint">⚠ Select a CF7 Form in the <strong>Details</strong> tab first.</p>
					) }
				</div>
			) }
		</div>
	);
}
